<template>

	<v-card class="px-2 py-5 my-3 posrel text-caption text-sm-body-1" elevation="20">
		<div class="d-flex align-center" v-if="compact">
			<v-btn @click="$nao.pronounce($nao.disassemble(e.nao))" icon style="height: 20px"><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
			<div class="text--secondary">
				{{ e.part_of_speech || '-' }}
			</div>
		</div>

		<div class="d-flex">
			<div v-if="!compact">
				<div class="pron_btn d-flex align-center">
					<v-btn @click="$nao.pronounce($nao.disassemble(e.nao))" icon><v-icon> {{ $mdi.VolumeHigh }} </v-icon></v-btn>
				</div>
				<div class="d-flex flex-column justify-center align-center px-3 pt-4">
					<div :class="k">{{e.nao}}</div>
					<div class="text--secondary">
						{{ e.part_of_speech || '-' }}
					</div>
				</div>
			</div>

			<div class="d-flex flex-column justify-center">
				<div v-for="t in ['nao','main_tr']" v-if="(e.attrs.includes('v') || e.attrs.includes('adj') || e.attrs.includes('tr')) || t == 'main_tr' || compact">
					<span v-if="e.attrs.includes('v') || e.attrs.includes('adj')" :class="ac">x</span>
					<span :class="{'font-weight-medium text-h5': t == 'nao'}"> {{ e.attrs.includes('adj') && t == 'main_tr' ? 'is ' : '' }} {{ e[t] }} </span>
					<span v-if="e.attrs.includes('tr')" :class="ac + ' orange'">y</span>
				</div>
				<div v-if="e.attrs.includes('tr')" class="text--secondary">
					Object type:
					<span v-if="e.attrs.includes('-sent')">clause, {{ verb_descr(e.attrs) }}, noun</span>
					<span v-else-if="e.attrs.includes('-verb')"> {{ verb_descr(e.attrs) }}, noun</span>
					<span v-else-if="e.attrs.includes('-noun')">noun</span>
				</div>
			</div>
		</div>
	</v-card>

</template>

<script>

export default {
	props: {
		e: Object,
		compact: Boolean
	},
	components: {},
	data() {
		return {

		}
	},
	methods: {
		verb_descr(attrs) {
			return attrs.includes('repsubj') ? 'verb (repsubj)' : 'verb';
		}
	},
	computed: {
		k() {
			return 'd-flex justify-center align-center text-h4 elem ' + this.$css.naoword;
		},
		ac() {
			return 'arg text-body-2 text-md-h5';
		}
	},
	created() {

	}
}
</script>

<style scoped>

table {
	xborder-collapse: collapse;
}

td {
	xborder: 1px solid black;
}

.v-card {
	width: 100%;
}

.elem {
	width: 100px;
}

.arg {
	font-family: MJXZERO, MJXTEX-I !important;
	font-weight: bold;
	border: 1px solid black;
	border-radius: 5px;
	border-color: #aaa;
	border-style: dashed;
	background-color: hsl(224, 100%, 90%);
	padding: 2px 10px;
	margin: 3px;
	font-style: italic;
	xfont-size: 25px;
}

.orange {
	background-color: #ff980073 !important;
}

.xv-card:hover {
	transform: scale(1.05);
	z-index: 3;
}

.v-card {
	transition: transform 0.2s;
	position: relative;
}

.v-card > .xv-btn {
	position: absolute;
	top: 35%;
	left: 10px;
}

.posrel {
	position: relative;
}

.pron_btn {
	position: absolute;
	left: 0px;
	top: 0px;
	height: 100%;
}

</style>